/*
* +------------------------------------------------------------------------+
* | Licensed Materials - Property of IBM
* | IBM Cognos Products: Dashboard
* | (C) Copyright IBM Corp. 2017
* |
* | US Government Users Restricted Rights - Use, duplication or disclosure
* | restricted by GSA ADP Schedule Contract with IBM Corp.
* +------------------------------------------------------------------------+
*/

define([
	'underscore'
], function(_) {
	'use strict';

	/**
	 *@constructor
	 */
	var ModuleUtils = {
		SHAPING: {
			DATAITEM_CHANGED: 0
		}
	};

	ModuleUtils.updateDataItemId = function(dataItemId, querySubjectId) {
		var id = dataItemId;
		var idParts = id.split('.');
		return id.replace(idParts[0], querySubjectId);
	};

	ModuleUtils.getColumnPropertyValue = function(metaDataColumn, propertyName) {
		var property;
		if (metaDataColumn.moserObject.getProperty) {
			property = _.find(metaDataColumn.moserObject.getProperty(), function(prop) {
				return prop.getName() === propertyName;
			});
		}
		return property ? property.getValue() : null;
	};

	return ModuleUtils;
});
